import * as service from './service'
export default {
  namespace: 'newOrderCancelReasonRetain',
  state: {
    punishDescription: '',
    punishList: [],
    lossAmount: ''
  },
  effects: {
    * getOrderCancelReasons ({ payload }, { call, put }) {
      const res = yield call(service.getOrderCancelReasons, payload)
      const data = res.data.data
      yield put({
        type: 'save',
        payload: {
          punishDescription: data?.punishDescription || '',
          punishList: data?.punishList || [],
          lossAmount: data?.lossAmount || ''
        }
      })
      return data
    },
    * abortOrder ({ payload }, { call, put }) {
      const res = yield call(service.abortOrder, payload)
      return res.data
    },
    * punishRule ({ payload }, { call, put }) {
      const res = yield call(service.punishRule, payload)
      return res.data
    },
    * beforeAbort ({ payload }, { call, put }) {
      const res = yield call(service.beforeAbort, payload)
      return res.data
    },
    * priceCollect ({ payload }, { call, put }) {
      const res = yield call(service.priceCollect, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
